import { KeyValuePipe, NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlaceOrderService } from '@app/services';
import { PaymentData, RoutingService } from 'haba-core';
import { EmporixPaymentService } from 'haba-emporix';

@Component({
  selector: 'app-authorize-payment',
  templateUrl: './authorize-payment.component.html',
  styleUrls: ['./authorize-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgIf, ReactiveFormsModule, FormsModule, NgFor, KeyValuePipe],
})
export class AuthorizePaymentComponent implements OnInit, OnDestroy {
  public paymentData: PaymentData;
  private iframeEventListener: EventListenerOrEventListenerObject;

  @ViewChild('form', { static: false }) set formEl(elRef: ElementRef) {
    if (elRef) {
      elRef.nativeElement.submit();
    }
  }

  constructor(
    private placeOrderService: PlaceOrderService,
    private routingService: RoutingService,
    private emporixPaymentService: EmporixPaymentService
  ) {}

  ngOnInit(): void {
    this.iframeEventListener = this.emporixPaymentService.getPaymentIframeEventListener();

    window.addEventListener('message', this.iframeEventListener);

    if (this.placeOrderService.paymentData) {
      this.paymentData = this.placeOrderService.paymentData;
    } else {
      this.routingService.back();
    }
  }

  ngOnDestroy(): void {
    if (this.iframeEventListener) {
      window.removeEventListener('message', this.iframeEventListener);
    }
  }
}
